import React from "react";
import Radio from "../Forms/Radio";
import CONSTANTS from "../../Constants";
import './PersonalInfoForm.scss'
import Input from "../Forms/Input";
import { Select } from "../Forms/Forms";
import { getNewPhoneFormatValue } from "../../helpers/helpers";
const PersonalInfoForm = ({ onFormInputsChange, onEmailBlur, formStateProps, errorStateProps }) => {
    const isPhoneNumberOptional = !!Number(window.siteConfig.MakePhoneNumberOptional);
    const ShowGenderNeutre = !!Number(window.siteConfig['LocalNeutre']);
    const email = CONSTANTS.LABELS.userinfos_email;
    const tel = CONSTANTS.LABELS.userinfos_tel;
    const sms =  CONSTANTS.LABELS.userinfos_sms;
    const contactOptions = isPhoneNumberOptional && !formStateProps.phone.length ?
        { [email]: CONSTANTS.LABELS.userinfos_email }
        :
        {   
            [email]: CONSTANTS.LABELS.userinfos_email,
            [tel]: CONSTANTS.LABELS.userinfos_tel,
            [sms]: CONSTANTS.LABELS.userinfos_sms
            
        }
    return (
        <div className='section-form'>
            <div className='civility-block'>
                <div className='form-row civility'>
                    <label tabIndex="0" className='label' htmlFor="civility"> {CONSTANTS.LABELS.userinfos_civility}</label>
                    <div className='radio_button-block'>
                        <Radio
                            name="civility"
                            id="civility-M"
                            label={CONSTANTS.LABELS.userinfos_mister}
                            value="Common_Sir"
                            isChecked={formStateProps.civility === 'Common_Sir'}
                            onChange={onFormInputsChange}
                        />

                        <Radio
                            name="civility"
                            id="civility-F"
                            label={CONSTANTS.LABELS.userinfos_madam}
                            value="Common_Madam"
                            isChecked={formStateProps.civility === 'Common_Madam'}
                            onChange={onFormInputsChange}
                        />
                        {ShowGenderNeutre && <Radio
                            name="civility"
                            id="civility-N"
                            label={CONSTANTS.LABELS.userinfos_neutral}
                            value="Common_Neutre"
                            isChecked={(formStateProps.civility == 'Common_Neutre')}
                            onChange={onFormInputsChange}
                        />}
                    </div>
                </div>
                {errorStateProps.showFormError && !formStateProps.civility && <div tabIndex="0" className="error input-errorLabel">
                    {CONSTANTS.LABELS.userinfos_error.replace("[nom_du_champ]", CONSTANTS.LABELS.userinfos_civility)}
                </div>}
            </div>

            <div className='form-row firstname'>
                <Input
                    name="firstName"
                    label={CONSTANTS.LABELS.userinfos_firstname}
                    Value={formStateProps.firstName}
                    errorLabel={
                        (errorStateProps.showFormError && formStateProps.firstName.length < 1) ? CONSTANTS.LABELS.userinfos_error.replace("[nom_du_champ]", CONSTANTS.LABELS.userinfos_firstname) : ''
                    }
                    onChange={onFormInputsChange}
                />
                {errorStateProps.showFirstNameFormatError && <div tabIndex="0"  className='error input-errorLabel'>{CONSTANTS.LABELS.userinfos_error_nameformat}</div>}
                {errorStateProps.showFirstNameSpecialChar && <div tabIndex="0"  className='error input-errorLabel'>{CONSTANTS.LABELS.userinfos_error_name_special_char}</div>}
                {errorStateProps.showFirstNameMaxLength && <div tabIndex="0"  className='error input-errorLabel'>{CONSTANTS.LABELS.userinfos_error_name_max_length}</div>}
            </div>
            <div className='form-row lastName'>
                <Input
                    name="lastName"
                    label={CONSTANTS.LABELS.userinfos_lastname}
                    Value={formStateProps.lastName}
                    errorLabel={(errorStateProps.showFormError && formStateProps.lastName.length < 1) ? CONSTANTS.LABELS.userinfos_error.replace("[nom_du_champ]", CONSTANTS.LABELS.userinfos_lastname) : ''}
                    onChange={onFormInputsChange}
                />
                {errorStateProps.showLastNameFormatError && <div tabIndex="0" className='error input-errorLabel'>{CONSTANTS.LABELS.userinfos_error_nameformat}</div>}
                {errorStateProps.showLastNameSpecialChar && <div tabIndex="0"  className='error input-errorLabel'>{CONSTANTS.LABELS.userinfos_error_name_special_char}</div>}
                {errorStateProps.showLastNameMaxLength && <div tabIndex="0"  className='error input-errorLabel'>{CONSTANTS.LABELS.userinfos_error_name_max_length}</div>}
            </div>
            <div className='form-row email'>
                <Input
                    name="email"
                    label={CONSTANTS.LABELS.userinfos_email}
                    placeholder={CONSTANTS.SITE_INFO.EMAILMASK}
                    Value={formStateProps.email}
                    errorLabel={(errorStateProps.showEmailFormatError || (errorStateProps.showFormError && formStateProps.email.length < 1)) ? CONSTANTS.LABELS.userinfos_error.replace("[nom_du_champ]", CONSTANTS.LABELS.userinfos_email) : ''}
                    onChange={onFormInputsChange}
                    onBlur={onEmailBlur}
                />
            </div>
            <div className='form-row phoneNumber'>
                <Input
                    name={"phone"}
                    label={CONSTANTS.LABELS.userinfos_tel}
                    placeholder={CONSTANTS.LABELS.userinfos_tel_example}
                    Value={getNewPhoneFormatValue(formStateProps.phone)}
                    errorLabel={errorStateProps.showFormError && errorStateProps.showPhoneFormatError ? CONSTANTS.LABELS.userinfos_error.replace("[nom_du_champ]", CONSTANTS.LABELS.userinfos_tel) : ''}
                    onChange={onFormInputsChange}
                />
            </div>

            <div className='form-row contactTypes'>
                <Select
                    label={CONSTANTS.LABELS.userinfos_contact_mode}
                    Options={contactOptions}
                    Selected={formStateProps.contactTypes ? formStateProps.contactTypes : 'Email'}
                    Name="contactTypes"
                    onChange={onFormInputsChange}

                />
            </div>
        </div>
    );
}
export default PersonalInfoForm;